import React from 'react';
import styles from './UpdateNotification.module.scss';

interface UpdateNotificationProps {
  isVisible: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  isVisible,
  onUpdate,
  onDismiss,
}) => {
  if (!isVisible) return null;

  return (
    <div className={styles.updateNotification}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" fill="#000"/>
          </svg>
        </div>
        <div className={styles.text}>
          <strong>New version available!</strong>
          <span>Click update to get the latest features.</span>
        </div>
      </div>
      <div className={styles.actions}>
        <button className={styles.later} onClick={onDismiss}>
          Later
        </button>
        <button onClick={onUpdate}>
          Update Now
        </button>
      </div>
    </div>
  );
};

export default UpdateNotification;
